// import components
import CustomScrollContainer from 'components/roster-portal/activity-planning/components/CustomScrollContainer/CustomScrollContainer';

// import hooks
import { useEffect } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { useRecoilValue } from 'recoil';

// import state
import { dragActionActiveAtom } from 'components/roster-portal/activity-planning/atoms';

// import types
import { ToPlanDropzoneProps } from './ToPlanDropzone.types';

// import utils
import { t } from 'i18next';

// import styles
import {
  StyledOverlayBox,
  StyledToPlanContainerBox
} from './ToPlanDropzone.styles';
import { StyledBoxFlexJustifyCenter } from 'components/shared/Box/Box.styles';

export default function ToPlanDropzone({
  children,
  handleDrop
}: ToPlanDropzoneProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: 'TO_PLAN_DROPZONE',
    data: {
      planningEntityType: '',
      appointmentGroupingEntityId: '',
      planningEntityIdentifier: {
        entityId: ''
      },
      scheduleStart: '',
      isToPlan: true
    }
  });

  const dragActionActive = useRecoilValue(dragActionActiveAtom);

  useEffect(() => {
    if (isOver) {
      handleDrop && handleDrop(); // Trigger handleDrop when task is dropped
    }
  }, [isOver, handleDrop]);

  return (
    <StyledToPlanContainerBox ref={setNodeRef} component="div" isOver={isOver}>
      <CustomScrollContainer dragActionActive={dragActionActive}>
        <StyledBoxFlexJustifyCenter>{children}</StyledBoxFlexJustifyCenter>
        {isOver && (
          <StyledOverlayBox>{t(`taskList.dropZone`)}</StyledOverlayBox>
        )}
      </CustomScrollContainer>
    </StyledToPlanContainerBox>
  );
}
